<template>
	<CmsIntroContainer :page="data">
		<template #h1>
			<h1 v-if="data?.seo_h1">{{ data.seo_h1 }}</h1>
		</template>
	</CmsIntroContainer>
</template>

<script setup>
	const {data} = inject('baseCmsPageData');
</script>